// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Alert = require("../common/Components/Alert.bs.js");
var React = require("react");
var ButtonsV5 = require("../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
var Formality = require("../../vendor/re-formality/Formality.bs.js");
var OptionExt = require("../common/OptionExt.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Form__Input = require("../../uikit/reason/atoms/Form/Form__Input.bs.js");
var Form__Label = require("../../uikit/reason/atoms/Form/Form__Label.bs.js");
var FormalityUI = require("../common/Form/FormalityUI.bs.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var Formality__ReactUpdate = require("../../vendor/re-formality/Formality__ReactUpdate.bs.js");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
var EditMarketingProfileMemberSocialAccountsFormMutation_graphql = require("../../__generated__/EditMarketingProfileMemberSocialAccountsFormMutation_graphql.bs.js");
var EditMarketingProfileMemberSocialAccountsForm_marketingProfileMember_graphql = require("../../__generated__/EditMarketingProfileMemberSocialAccountsForm_marketingProfileMember_graphql.bs.js");

var validators = {
  yelp: undefined,
  tikTok: undefined,
  youTube: undefined,
  linkedIn: undefined,
  instagram: undefined,
  facebook: undefined,
  twitter: undefined
};

function initialFieldsStatuses(_input) {
  return {
          yelp: "Pristine",
          tikTok: "Pristine",
          youTube: "Pristine",
          linkedIn: "Pristine",
          instagram: "Pristine",
          facebook: "Pristine",
          twitter: "Pristine"
        };
}

function initialState(input) {
  return {
          input: input,
          fieldsStatuses: initialFieldsStatuses(input),
          collectionsStatuses: undefined,
          formStatus: "Editing",
          submissionStatus: "NeverSubmitted"
        };
}

function validateForm(input, param, param$1) {
  var match_0 = {
    TAG: "Ok",
    _0: input.yelp
  };
  var match_0$1 = {
    TAG: "Ok",
    _0: input.tikTok
  };
  var match_0$2 = {
    TAG: "Ok",
    _0: input.youTube
  };
  var match_0$3 = {
    TAG: "Ok",
    _0: input.linkedIn
  };
  var match_0$4 = {
    TAG: "Ok",
    _0: input.instagram
  };
  var match_0$5 = {
    TAG: "Ok",
    _0: input.facebook
  };
  var match_0$6 = {
    TAG: "Ok",
    _0: input.twitter
  };
  var yelpResult = match_0;
  var yelpResult$1;
  if (yelpResult.TAG === "Ok") {
    var tikTokResult = match_0$1;
    if (tikTokResult.TAG === "Ok") {
      var youTubeResult = match_0$2;
      if (youTubeResult.TAG === "Ok") {
        var linkedInResult = match_0$3;
        if (linkedInResult.TAG === "Ok") {
          var instagramResult = match_0$4;
          if (instagramResult.TAG === "Ok") {
            var facebookResult = match_0$5;
            if (facebookResult.TAG === "Ok") {
              var twitterResult = match_0$6;
              if (twitterResult.TAG === "Ok") {
                return {
                        TAG: "Valid",
                        output: {
                          twitter: twitterResult._0,
                          facebook: facebookResult._0,
                          instagram: instagramResult._0,
                          linkedIn: linkedInResult._0,
                          youTube: youTubeResult._0,
                          tikTok: tikTokResult._0,
                          yelp: yelpResult._0
                        },
                        fieldsStatuses: {
                          yelp: {
                            TAG: "Dirty",
                            _0: yelpResult,
                            _1: "Hidden"
                          },
                          tikTok: {
                            TAG: "Dirty",
                            _0: tikTokResult,
                            _1: "Hidden"
                          },
                          youTube: {
                            TAG: "Dirty",
                            _0: youTubeResult,
                            _1: "Hidden"
                          },
                          linkedIn: {
                            TAG: "Dirty",
                            _0: linkedInResult,
                            _1: "Hidden"
                          },
                          instagram: {
                            TAG: "Dirty",
                            _0: instagramResult,
                            _1: "Hidden"
                          },
                          facebook: {
                            TAG: "Dirty",
                            _0: facebookResult,
                            _1: "Hidden"
                          },
                          twitter: {
                            TAG: "Dirty",
                            _0: twitterResult,
                            _1: "Hidden"
                          }
                        },
                        collectionsStatuses: undefined
                      };
              }
              yelpResult$1 = yelpResult;
            } else {
              yelpResult$1 = yelpResult;
            }
          } else {
            yelpResult$1 = yelpResult;
          }
        } else {
          yelpResult$1 = yelpResult;
        }
      } else {
        yelpResult$1 = yelpResult;
      }
    } else {
      yelpResult$1 = yelpResult;
    }
  } else {
    yelpResult$1 = yelpResult;
  }
  return {
          TAG: "Invalid",
          fieldsStatuses: {
            yelp: {
              TAG: "Dirty",
              _0: yelpResult$1,
              _1: "Hidden"
            },
            tikTok: {
              TAG: "Dirty",
              _0: match_0$1,
              _1: "Hidden"
            },
            youTube: {
              TAG: "Dirty",
              _0: match_0$2,
              _1: "Hidden"
            },
            linkedIn: {
              TAG: "Dirty",
              _0: match_0$3,
              _1: "Hidden"
            },
            instagram: {
              TAG: "Dirty",
              _0: match_0$4,
              _1: "Hidden"
            },
            facebook: {
              TAG: "Dirty",
              _0: match_0$5,
              _1: "Hidden"
            },
            twitter: {
              TAG: "Dirty",
              _0: match_0$6,
              _1: "Hidden"
            }
          },
          collectionsStatuses: undefined
        };
}

function useForm(initialInput, onSubmit) {
  var memoizedInitialState = React.useMemo((function () {
          return initialState(initialInput);
        }), [initialInput]);
  var match = Formality__ReactUpdate.useReducer(memoizedInitialState, (function (state, action) {
          if (typeof action !== "object") {
            switch (action) {
              case "BlurYelpField" :
                  var result = Formality.validateFieldOnBlurWithoutValidator(state.input.yelp, state.fieldsStatuses.yelp, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  yelp: status,
                                  tikTok: init.tikTok,
                                  youTube: init.youTube,
                                  linkedIn: init.linkedIn,
                                  instagram: init.instagram,
                                  facebook: init.facebook,
                                  twitter: init.twitter
                                };
                        }));
                  if (result !== undefined) {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: result,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return "NoUpdate";
                  }
              case "BlurTikTokField" :
                  var result$1 = Formality.validateFieldOnBlurWithoutValidator(state.input.tikTok, state.fieldsStatuses.tikTok, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  yelp: init.yelp,
                                  tikTok: status,
                                  youTube: init.youTube,
                                  linkedIn: init.linkedIn,
                                  instagram: init.instagram,
                                  facebook: init.facebook,
                                  twitter: init.twitter
                                };
                        }));
                  if (result$1 !== undefined) {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$1,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return "NoUpdate";
                  }
              case "BlurYouTubeField" :
                  var result$2 = Formality.validateFieldOnBlurWithoutValidator(state.input.youTube, state.fieldsStatuses.youTube, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  yelp: init.yelp,
                                  tikTok: init.tikTok,
                                  youTube: status,
                                  linkedIn: init.linkedIn,
                                  instagram: init.instagram,
                                  facebook: init.facebook,
                                  twitter: init.twitter
                                };
                        }));
                  if (result$2 !== undefined) {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$2,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return "NoUpdate";
                  }
              case "BlurLinkedInField" :
                  var result$3 = Formality.validateFieldOnBlurWithoutValidator(state.input.linkedIn, state.fieldsStatuses.linkedIn, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  yelp: init.yelp,
                                  tikTok: init.tikTok,
                                  youTube: init.youTube,
                                  linkedIn: status,
                                  instagram: init.instagram,
                                  facebook: init.facebook,
                                  twitter: init.twitter
                                };
                        }));
                  if (result$3 !== undefined) {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$3,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return "NoUpdate";
                  }
              case "BlurInstagramField" :
                  var result$4 = Formality.validateFieldOnBlurWithoutValidator(state.input.instagram, state.fieldsStatuses.instagram, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  yelp: init.yelp,
                                  tikTok: init.tikTok,
                                  youTube: init.youTube,
                                  linkedIn: init.linkedIn,
                                  instagram: status,
                                  facebook: init.facebook,
                                  twitter: init.twitter
                                };
                        }));
                  if (result$4 !== undefined) {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$4,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return "NoUpdate";
                  }
              case "BlurFacebookField" :
                  var result$5 = Formality.validateFieldOnBlurWithoutValidator(state.input.facebook, state.fieldsStatuses.facebook, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  yelp: init.yelp,
                                  tikTok: init.tikTok,
                                  youTube: init.youTube,
                                  linkedIn: init.linkedIn,
                                  instagram: init.instagram,
                                  facebook: status,
                                  twitter: init.twitter
                                };
                        }));
                  if (result$5 !== undefined) {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$5,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return "NoUpdate";
                  }
              case "BlurTwitterField" :
                  var result$6 = Formality.validateFieldOnBlurWithoutValidator(state.input.twitter, state.fieldsStatuses.twitter, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  yelp: init.yelp,
                                  tikTok: init.tikTok,
                                  youTube: init.youTube,
                                  linkedIn: init.linkedIn,
                                  instagram: init.instagram,
                                  facebook: init.facebook,
                                  twitter: status
                                };
                        }));
                  if (result$6 !== undefined) {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$6,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return "NoUpdate";
                  }
              case "Submit" :
                  var match = state.formStatus;
                  if (typeof match === "object" && match.TAG === "Submitting") {
                    return "NoUpdate";
                  }
                  var match$1 = validateForm(state.input, validators, state.fieldsStatuses);
                  if (match$1.TAG !== "Valid") {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: match$1.fieldsStatuses,
                              collectionsStatuses: match$1.collectionsStatuses,
                              formStatus: "Editing",
                              submissionStatus: "AttemptedToSubmit"
                            }
                          };
                  }
                  var output = match$1.output;
                  var error = state.formStatus;
                  var tmp;
                  tmp = typeof error !== "object" || error.TAG !== "SubmissionFailed" ? undefined : Caml_option.some(error._0);
                  return {
                          TAG: "UpdateWithSideEffects",
                          _0: {
                            input: state.input,
                            fieldsStatuses: match$1.fieldsStatuses,
                            collectionsStatuses: match$1.collectionsStatuses,
                            formStatus: {
                              TAG: "Submitting",
                              _0: tmp
                            },
                            submissionStatus: "AttemptedToSubmit"
                          },
                          _1: (function (param) {
                              var dispatch = param.dispatch;
                              onSubmit(output, {
                                    notifyOnSuccess: (function (input) {
                                        dispatch({
                                              TAG: "SetSubmittedStatus",
                                              _0: input
                                            });
                                      }),
                                    notifyOnFailure: (function (error) {
                                        dispatch({
                                              TAG: "SetSubmissionFailedStatus",
                                              _0: error
                                            });
                                      }),
                                    reset: (function () {
                                        dispatch("Reset");
                                      }),
                                    dismissSubmissionResult: (function () {
                                        dispatch("DismissSubmissionResult");
                                      })
                                  });
                            })
                        };
                  break;
              case "DismissSubmissionError" :
                  var match$2 = state.formStatus;
                  if (typeof match$2 !== "object" || match$2.TAG !== "SubmissionFailed") {
                    return "NoUpdate";
                  } else {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: "Editing",
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case "DismissSubmissionResult" :
                  var match$3 = state.formStatus;
                  if (typeof match$3 !== "object") {
                    if (match$3 === "Editing") {
                      return "NoUpdate";
                    }
                    
                  } else if (match$3.TAG === "Submitting") {
                    return "NoUpdate";
                  }
                  return {
                          TAG: "Update",
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: "Editing",
                            submissionStatus: state.submissionStatus
                          }
                        };
              case "Reset" :
                  return {
                          TAG: "Update",
                          _0: initialState(initialInput)
                        };
              
            }
          } else {
            switch (action.TAG) {
              case "UpdateYelpField" :
                  var nextInput = action._0(state.input);
                  return {
                          TAG: "Update",
                          _0: {
                            input: nextInput,
                            fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput.yelp, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            yelp: status,
                                            tikTok: init.tikTok,
                                            youTube: init.youTube,
                                            linkedIn: init.linkedIn,
                                            instagram: init.instagram,
                                            facebook: init.facebook,
                                            twitter: init.twitter
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case "UpdateTikTokField" :
                  var nextInput$1 = action._0(state.input);
                  return {
                          TAG: "Update",
                          _0: {
                            input: nextInput$1,
                            fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput$1.tikTok, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            yelp: init.yelp,
                                            tikTok: status,
                                            youTube: init.youTube,
                                            linkedIn: init.linkedIn,
                                            instagram: init.instagram,
                                            facebook: init.facebook,
                                            twitter: init.twitter
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case "UpdateYouTubeField" :
                  var nextInput$2 = action._0(state.input);
                  return {
                          TAG: "Update",
                          _0: {
                            input: nextInput$2,
                            fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput$2.youTube, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            yelp: init.yelp,
                                            tikTok: init.tikTok,
                                            youTube: status,
                                            linkedIn: init.linkedIn,
                                            instagram: init.instagram,
                                            facebook: init.facebook,
                                            twitter: init.twitter
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case "UpdateLinkedInField" :
                  var nextInput$3 = action._0(state.input);
                  return {
                          TAG: "Update",
                          _0: {
                            input: nextInput$3,
                            fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput$3.linkedIn, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            yelp: init.yelp,
                                            tikTok: init.tikTok,
                                            youTube: init.youTube,
                                            linkedIn: status,
                                            instagram: init.instagram,
                                            facebook: init.facebook,
                                            twitter: init.twitter
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case "UpdateInstagramField" :
                  var nextInput$4 = action._0(state.input);
                  return {
                          TAG: "Update",
                          _0: {
                            input: nextInput$4,
                            fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput$4.instagram, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            yelp: init.yelp,
                                            tikTok: init.tikTok,
                                            youTube: init.youTube,
                                            linkedIn: init.linkedIn,
                                            instagram: status,
                                            facebook: init.facebook,
                                            twitter: init.twitter
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case "UpdateFacebookField" :
                  var nextInput$5 = action._0(state.input);
                  return {
                          TAG: "Update",
                          _0: {
                            input: nextInput$5,
                            fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput$5.facebook, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            yelp: init.yelp,
                                            tikTok: init.tikTok,
                                            youTube: init.youTube,
                                            linkedIn: init.linkedIn,
                                            instagram: init.instagram,
                                            facebook: status,
                                            twitter: init.twitter
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case "UpdateTwitterField" :
                  var nextInput$6 = action._0(state.input);
                  return {
                          TAG: "Update",
                          _0: {
                            input: nextInput$6,
                            fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput$6.twitter, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            yelp: init.yelp,
                                            tikTok: init.tikTok,
                                            youTube: init.youTube,
                                            linkedIn: init.linkedIn,
                                            instagram: init.instagram,
                                            facebook: init.facebook,
                                            twitter: status
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case "SetSubmittedStatus" :
                  var input = action._0;
                  if (input !== undefined) {
                    return {
                            TAG: "Update",
                            _0: {
                              input: input,
                              fieldsStatuses: initialFieldsStatuses(input),
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: "Submitted",
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: initialFieldsStatuses(state.input),
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: "Submitted",
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case "SetSubmissionFailedStatus" :
                  return {
                          TAG: "Update",
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: {
                              TAG: "SubmissionFailed",
                              _0: action._0
                            },
                            submissionStatus: state.submissionStatus
                          }
                        };
              case "MapSubmissionError" :
                  var map = action._0;
                  var error$1 = state.formStatus;
                  if (typeof error$1 !== "object") {
                    return "NoUpdate";
                  }
                  if (error$1.TAG !== "Submitting") {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: "SubmissionFailed",
                                _0: map(error$1._0)
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
                  var error$2 = error$1._0;
                  if (error$2 !== undefined) {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: "Submitting",
                                _0: Caml_option.some(map(Caml_option.valFromOption(error$2)))
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return "NoUpdate";
                  }
              
            }
          }
        }));
  var dispatch = match[1];
  var state = match[0];
  var match$1 = state.formStatus;
  var tmp;
  tmp = typeof match$1 !== "object" || match$1.TAG !== "Submitting" ? false : true;
  return {
          updateYelp: (function (nextInputFn, nextValue) {
              dispatch({
                    TAG: "UpdateYelpField",
                    _0: (function (__x) {
                        return nextInputFn(__x, nextValue);
                      })
                  });
            }),
          updateTikTok: (function (nextInputFn, nextValue) {
              dispatch({
                    TAG: "UpdateTikTokField",
                    _0: (function (__x) {
                        return nextInputFn(__x, nextValue);
                      })
                  });
            }),
          updateYouTube: (function (nextInputFn, nextValue) {
              dispatch({
                    TAG: "UpdateYouTubeField",
                    _0: (function (__x) {
                        return nextInputFn(__x, nextValue);
                      })
                  });
            }),
          updateLinkedIn: (function (nextInputFn, nextValue) {
              dispatch({
                    TAG: "UpdateLinkedInField",
                    _0: (function (__x) {
                        return nextInputFn(__x, nextValue);
                      })
                  });
            }),
          updateInstagram: (function (nextInputFn, nextValue) {
              dispatch({
                    TAG: "UpdateInstagramField",
                    _0: (function (__x) {
                        return nextInputFn(__x, nextValue);
                      })
                  });
            }),
          updateFacebook: (function (nextInputFn, nextValue) {
              dispatch({
                    TAG: "UpdateFacebookField",
                    _0: (function (__x) {
                        return nextInputFn(__x, nextValue);
                      })
                  });
            }),
          updateTwitter: (function (nextInputFn, nextValue) {
              dispatch({
                    TAG: "UpdateTwitterField",
                    _0: (function (__x) {
                        return nextInputFn(__x, nextValue);
                      })
                  });
            }),
          blurYelp: (function () {
              dispatch("BlurYelpField");
            }),
          blurTikTok: (function () {
              dispatch("BlurTikTokField");
            }),
          blurYouTube: (function () {
              dispatch("BlurYouTubeField");
            }),
          blurLinkedIn: (function () {
              dispatch("BlurLinkedInField");
            }),
          blurInstagram: (function () {
              dispatch("BlurInstagramField");
            }),
          blurFacebook: (function () {
              dispatch("BlurFacebookField");
            }),
          blurTwitter: (function () {
              dispatch("BlurTwitterField");
            }),
          yelpResult: Formality.exposeFieldResult(state.fieldsStatuses.yelp),
          tikTokResult: Formality.exposeFieldResult(state.fieldsStatuses.tikTok),
          youTubeResult: Formality.exposeFieldResult(state.fieldsStatuses.youTube),
          linkedInResult: Formality.exposeFieldResult(state.fieldsStatuses.linkedIn),
          instagramResult: Formality.exposeFieldResult(state.fieldsStatuses.instagram),
          facebookResult: Formality.exposeFieldResult(state.fieldsStatuses.facebook),
          twitterResult: Formality.exposeFieldResult(state.fieldsStatuses.twitter),
          input: state.input,
          status: state.formStatus,
          dirty: (function () {
              var match = state.fieldsStatuses;
              var tmp = match.yelp;
              if (typeof tmp === "object") {
                return true;
              }
              var tmp$1 = match.tikTok;
              if (typeof tmp$1 === "object") {
                return true;
              }
              var tmp$2 = match.youTube;
              if (typeof tmp$2 === "object") {
                return true;
              }
              var tmp$3 = match.linkedIn;
              if (typeof tmp$3 === "object") {
                return true;
              }
              var tmp$4 = match.instagram;
              if (typeof tmp$4 === "object") {
                return true;
              }
              var tmp$5 = match.facebook;
              if (typeof tmp$5 === "object") {
                return true;
              }
              var tmp$6 = match.twitter;
              if (typeof tmp$6 !== "object") {
                return false;
              } else {
                return true;
              }
            }),
          valid: (function () {
              var match = validateForm(state.input, validators, state.fieldsStatuses);
              if (match.TAG === "Valid") {
                return true;
              } else {
                return false;
              }
            }),
          submitting: tmp,
          submit: (function () {
              dispatch("Submit");
            }),
          dismissSubmissionError: (function () {
              dispatch("DismissSubmissionError");
            }),
          dismissSubmissionResult: (function () {
              dispatch("DismissSubmissionResult");
            }),
          mapSubmissionError: (function (map) {
              dispatch({
                    TAG: "MapSubmissionError",
                    _0: map
                  });
            }),
          reset: (function () {
              dispatch("Reset");
            })
        };
}

var Config = {
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

var convertFragment = EditMarketingProfileMemberSocialAccountsForm_marketingProfileMember_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, EditMarketingProfileMemberSocialAccountsForm_marketingProfileMember_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(EditMarketingProfileMemberSocialAccountsForm_marketingProfileMember_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, EditMarketingProfileMemberSocialAccountsForm_marketingProfileMember_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(EditMarketingProfileMemberSocialAccountsForm_marketingProfileMember_graphql.node, convertFragment, fRef);
}

var Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function initialInputFromFragment(fragment) {
  var match = fragment.socialAccounts;
  return {
          twitter: OptionExt.toString(match.twitter),
          facebook: OptionExt.toString(match.facebook),
          instagram: OptionExt.toString(match.instagram),
          linkedIn: OptionExt.toString(match.linkedIn),
          youTube: OptionExt.toString(match.youTube),
          tikTok: OptionExt.toString(match.tikTok),
          yelp: OptionExt.toString(match.yelp)
        };
}

function EditMarketingProfileMemberSocialAccountsForm$InputField(props) {
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx(Form__Label.make, {
                            labelText: props.labelText
                          }),
                      className: "pt-2"
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx(Form__Input.make, {
                              placeholderText: props.placeholder,
                              onChange: props.onChange,
                              onBlur: props.onBlur,
                              status: FormalityUI.UIKitStatus.ofOptFieldResult(props.status),
                              value: props.value
                            }),
                        Core__Option.getOr(Core__Option.map(props.helpText, (function (text) {
                                    return JsxRuntime.jsx("div", {
                                                children: text,
                                                className: "text-base text-gray-500"
                                              });
                                  })), null)
                      ],
                      className: "mt-2 sm:col-span-2 sm:mt-0 sm:max-w-xs space-y-3"
                    })
              ],
              className: "sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-6"
            });
}

var InputField = {
  make: EditMarketingProfileMemberSocialAccountsForm$InputField
};

var convertVariables = EditMarketingProfileMemberSocialAccountsFormMutation_graphql.Internal.convertVariables;

var convertResponse = EditMarketingProfileMemberSocialAccountsFormMutation_graphql.Internal.convertResponse;

var convertWrapRawResponse = EditMarketingProfileMemberSocialAccountsFormMutation_graphql.Internal.convertWrapRawResponse;

var commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, EditMarketingProfileMemberSocialAccountsFormMutation_graphql.node, convertResponse, convertWrapRawResponse);

var use$1 = RescriptRelay_Mutation.useMutation(convertVariables, EditMarketingProfileMemberSocialAccountsFormMutation_graphql.node, convertResponse, convertWrapRawResponse);

var Mutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use$1
};

function EditMarketingProfileMemberSocialAccountsForm(props) {
  var member = use(props.member);
  var match = use$1();
  var mutate = match[0];
  var form = useForm(initialInputFromFragment(member), (function (param, param$1) {
          var notifyOnFailure = param$1.notifyOnFailure;
          var notifyOnSuccess = param$1.notifyOnSuccess;
          mutate({
                input: {
                  memberId: member.id,
                  socialAccounts: {
                    facebook: OptionExt.ofString(param.facebook),
                    instagram: OptionExt.ofString(param.instagram),
                    linkedIn: OptionExt.ofString(param.linkedIn),
                    tikTok: OptionExt.ofString(param.tikTok),
                    twitter: OptionExt.ofString(param.twitter),
                    yelp: OptionExt.ofString(param.yelp),
                    youTube: OptionExt.ofString(param.youTube)
                  }
                }
              }, undefined, undefined, undefined, (function (param, param$1) {
                  var result = param.updateMarketingProfileMemberSocialAccounts;
                  if (result !== undefined && result.__typename === "MarketingProfileMemberSocialAccountsUpdated") {
                    return notifyOnSuccess(undefined);
                  } else {
                    return notifyOnFailure();
                  }
                }), (function (param) {
                  notifyOnFailure();
                }), undefined);
        }));
  var match$1 = form.status;
  var tmp;
  tmp = typeof match$1 !== "object" ? (
      match$1 === "Editing" ? null : JsxRuntime.jsx(Alert.Success.make, {
              title: Core__Option.getOr(member.firstName, member.displayName) + "'s social accounts were updated"
            })
    ) : (
      match$1.TAG === "Submitting" ? null : JsxRuntime.jsx(Alert.$$Error.make, {
              title: "There was an error updating your account. Please try again"
            })
    );
  return JsxRuntime.jsx("form", {
              children: JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx(EditMarketingProfileMemberSocialAccountsForm$InputField, {
                                    onChange: (function ($$event) {
                                        form.updateTwitter((function (input, value) {
                                                return {
                                                        twitter: value,
                                                        facebook: input.facebook,
                                                        instagram: input.instagram,
                                                        linkedIn: input.linkedIn,
                                                        youTube: input.youTube,
                                                        tikTok: input.tikTok,
                                                        yelp: input.yelp
                                                      };
                                              }), $$event.target.value);
                                      }),
                                    onBlur: (function (param) {
                                        form.blurTwitter();
                                      }),
                                    value: form.input.twitter,
                                    status: form.twitterResult,
                                    labelText: "Twitter",
                                    placeholder: "URL or username"
                                  }),
                              JsxRuntime.jsx(EditMarketingProfileMemberSocialAccountsForm$InputField, {
                                    onChange: (function ($$event) {
                                        form.updateFacebook((function (input, value) {
                                                return {
                                                        twitter: input.twitter,
                                                        facebook: value,
                                                        instagram: input.instagram,
                                                        linkedIn: input.linkedIn,
                                                        youTube: input.youTube,
                                                        tikTok: input.tikTok,
                                                        yelp: input.yelp
                                                      };
                                              }), $$event.target.value);
                                      }),
                                    onBlur: (function (param) {
                                        form.blurFacebook();
                                      }),
                                    value: form.input.facebook,
                                    status: form.facebookResult,
                                    labelText: "Facebook",
                                    placeholder: "URL or username"
                                  }),
                              JsxRuntime.jsx(EditMarketingProfileMemberSocialAccountsForm$InputField, {
                                    onChange: (function ($$event) {
                                        form.updateInstagram((function (input, value) {
                                                return {
                                                        twitter: input.twitter,
                                                        facebook: input.facebook,
                                                        instagram: value,
                                                        linkedIn: input.linkedIn,
                                                        youTube: input.youTube,
                                                        tikTok: input.tikTok,
                                                        yelp: input.yelp
                                                      };
                                              }), $$event.target.value);
                                      }),
                                    onBlur: (function (param) {
                                        form.blurInstagram();
                                      }),
                                    value: form.input.instagram,
                                    status: form.instagramResult,
                                    labelText: "Instagram",
                                    placeholder: "URL or username"
                                  }),
                              JsxRuntime.jsx(EditMarketingProfileMemberSocialAccountsForm$InputField, {
                                    onChange: (function ($$event) {
                                        form.updateLinkedIn((function (input, value) {
                                                return {
                                                        twitter: input.twitter,
                                                        facebook: input.facebook,
                                                        instagram: input.instagram,
                                                        linkedIn: value,
                                                        youTube: input.youTube,
                                                        tikTok: input.tikTok,
                                                        yelp: input.yelp
                                                      };
                                              }), $$event.target.value);
                                      }),
                                    onBlur: (function (param) {
                                        form.blurLinkedIn();
                                      }),
                                    value: form.input.linkedIn,
                                    status: form.linkedInResult,
                                    labelText: "LinkedIn",
                                    placeholder: "URL"
                                  }),
                              JsxRuntime.jsx(EditMarketingProfileMemberSocialAccountsForm$InputField, {
                                    onChange: (function ($$event) {
                                        form.updateYouTube((function (input, value) {
                                                return {
                                                        twitter: input.twitter,
                                                        facebook: input.facebook,
                                                        instagram: input.instagram,
                                                        linkedIn: input.linkedIn,
                                                        youTube: value,
                                                        tikTok: input.tikTok,
                                                        yelp: input.yelp
                                                      };
                                              }), $$event.target.value);
                                      }),
                                    onBlur: (function (param) {
                                        form.blurYouTube();
                                      }),
                                    value: form.input.youTube,
                                    status: form.youTubeResult,
                                    labelText: "YouTube",
                                    placeholder: "URL or username"
                                  }),
                              JsxRuntime.jsx(EditMarketingProfileMemberSocialAccountsForm$InputField, {
                                    onChange: (function ($$event) {
                                        form.updateTikTok((function (input, value) {
                                                return {
                                                        twitter: input.twitter,
                                                        facebook: input.facebook,
                                                        instagram: input.instagram,
                                                        linkedIn: input.linkedIn,
                                                        youTube: input.youTube,
                                                        tikTok: value,
                                                        yelp: input.yelp
                                                      };
                                              }), $$event.target.value);
                                      }),
                                    onBlur: (function (param) {
                                        form.blurTikTok();
                                      }),
                                    value: form.input.tikTok,
                                    status: form.tikTokResult,
                                    labelText: "TikTok",
                                    placeholder: "URL or username"
                                  }),
                              JsxRuntime.jsx(EditMarketingProfileMemberSocialAccountsForm$InputField, {
                                    onChange: (function ($$event) {
                                        form.updateYelp((function (input, value) {
                                                return {
                                                        twitter: input.twitter,
                                                        facebook: input.facebook,
                                                        instagram: input.instagram,
                                                        linkedIn: input.linkedIn,
                                                        youTube: input.youTube,
                                                        tikTok: input.tikTok,
                                                        yelp: value
                                                      };
                                              }), $$event.target.value);
                                      }),
                                    onBlur: (function (param) {
                                        form.blurYelp();
                                      }),
                                    value: form.input.yelp,
                                    status: form.yelpResult,
                                    labelText: "Yelp",
                                    placeholder: "URL or username"
                                  })
                            ],
                            className: "space-y-8 border-b border-zinc-200 pb-12 sm:space-y-0 sm:divide-y sm:divide-zinc-200 sm:pb-0"
                          }),
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
                                    disabled: form.submitting,
                                    children: "Save Changes"
                                  }),
                              JsxRuntime.jsx("div", {
                                    children: tmp,
                                    role: "status"
                                  })
                            ],
                            className: "flex flex-col sm:flex-row gap-4 sm:items-center"
                          })
                    ],
                    className: "space-y-6"
                  }),
              onSubmit: (function ($$event) {
                  $$event.preventDefault();
                  form.submit();
                })
            });
}

var make = EditMarketingProfileMemberSocialAccountsForm;

exports.Config = Config;
exports.Fragment = Fragment;
exports.initialInputFromFragment = initialInputFromFragment;
exports.InputField = InputField;
exports.Mutation = Mutation;
exports.make = make;
/* commitMutation Not a pure module */
